"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _UploaderContext = require("../UploaderContext"),
    _getAssetsFromMap = _interopRequireDefault(require("./utils/getAssetsFromMap"));

function AssetSelector(a) {
  var b = a.assetIds,
      c = a.children;
  return _react["default"].createElement(_UploaderContext.UploaderConsumer, null, function (a) {
    var d = a.assetsMap;
    return c((0, _getAssetsFromMap["default"])(d, b));
  });
}

var _default = AssetSelector;
exports["default"] = _default;